module.exports = __webpack_public_path__ + "img/8.9db0fd6e.png";